<template>
  <section class="section section-l" id="faqs">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-lg-6">
          <div class="section-head section-head-s2">
            <h2 class="title title-xl animated" data-animate="fadeInUp" data-delay="0.1" title="FAQS">FAQS</h2>
            <p class="animated" data-animate="fadeInUp" data-delay="0.2">Below we’ve provided a bit of QuBit, eStamp and few others. If you have any other questions, please get in touch.</p>
          </div>
        </div>
      </div>
      <div class="nk-block">
        <div class="row justify-content-center">
          <div class="col-xl-10">
            <ul class="nav tab-nav tab-nav-btn tab-nav-center animated" data-animate="fadeInUp" data-delay="0.3">
              <li><a class="active" data-toggle="tab" href="#tab-2-1">General Questions</a></li>
              <li><a data-toggle="tab" href="#tab-2-2">Stamp Sales</a></li>
              <li><a data-toggle="tab" href="#tab-2-3">Agents</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane fade show active" id="tab-2-1">
                <div class="accordion" id="acc-1">
                  <div class="accordion-item accordion-item-s3 animated" data-animate="fadeInUp" data-delay="0.4">
                    <h5 class="accordion-title accordion-title-sm" data-toggle="collapse" data-target="#acc-1-1">What is Postage Stamp? 
                      <span class="accordion-icon"></span>
                    </h5>     
                    <div id="acc-1-1" class="collapse show" data-parent="#acc-1">
                      <div class="accordion-content">
                        <p>The Postage Stamp came with the efficiency of the postal service and ensured
                        that Post Offices are not losing revenue by providing an evidence that the person
                        had not only paid for the letter but had also paid the correct amount.</p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item accordion-item-s3 animated" data-animate="fadeInUp" data-delay="0.5">
                      <h5 class="accordion-title accordion-title-sm collapsed" data-toggle="collapse" data-target="#acc-1-2">Why NIPOST ESTAMP? 
                        <span class="accordion-icon"></span>
                      </h5>
                      <div id="acc-1-2" class="collapse" data-parent="#acc-1">
                        <div class="accordion-content">
                          <p>QuBit is first of it's kind electronic Stamp based on the original design of the
                          founding fathers with to integrate seamlessly with any technology without any disruption of the way business is done today.</p>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="tab-2-2">
                <div class="accordion" id="acc-2">
                  <div class="accordion-item accordion-item-s3 animated" data-animate="fadeInUp" data-delay="0.4"> 
                    <h5 class="accordion-title accordion-title-sm" data-toggle="collapse" data-target="#acc-2-1">What is QuBit? 
                      <span class="accordion-icon"></span>
                    </h5>    
                    <div id="acc-2-1" class="collapse show" data-parent="#acc-2">
                      <div class="accordion-content">
                        <p>The name QuBit is a unit in quantum computing which represents the ability of the new Electronic Stamp to take multiple forms at the same time.</p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item accordion-item-s3 animated" data-animate="fadeInUp" data-delay="0.6">  
                    <h5 class="accordion-title accordion-title-sm collapsed" data-toggle="collapse" data-target="#acc-2-3">How can NIPOST ESTAMP be generated? 
                      <span class="accordion-icon"></span>
                    </h5>   
                    <div id="acc-2-3" class="collapse" data-parent="#acc-2">
                      <div class="accordion-content">
                        <p>It supports Mobile, Web, POS, IOT, Visual technology and it has the capability to scale to      
                        1,653,241 stamps per sec making it 10x more powerful than any Data or Transaction Switch in Nigeria.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="tab-2-3">
                <div class="accordion" id="acc-3">
                  <div class="accordion-item accordion-item-s3 animated" data-animate="fadeInUp" data-delay="0.4">
                    <h5 class="accordion-title accordion-title-sm" data-toggle="collapse" data-target="#acc-3-1">How Can I become an Agent? 
                      <span class="accordion-icon"></span>
                    </h5>       
                    <div id="acc-3-1" class="collapse show" data-parent="#acc-3">
                      <div class="accordion-content">
                        <p>Visit any NIPOST office across the nation to make further enquiry</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>  
</template>

<script>
export default {

}
</script>

<style>

</style>